var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"r"},[_vm._v(_vm._s(_vm.title)+" "),_c('input',{attrs:{"type":"radio","name":"radio","id":_vm.text},domProps:{"checked":_vm.checked}}),_c('span',{staticClass:"rcheckmark"})])])}
var staticRenderFns = []

export { render, staticRenderFns }